import { render } from "./CollecteClients.vue?vue&type=template&id=a8a04006&scoped=true"
import script from "./CollecteClients.vue?vue&type=script&lang=js"
export * from "./CollecteClients.vue?vue&type=script&lang=js"

import "./CollecteClients.vue?vue&type=style&index=0&id=a8a04006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a04006"]])

export default __exports__